module.exports = __webpack_public_path__ + "img/Siemens.d41d8cd9.svg";